var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 41.7042,
    rx: 20.8521,
    fill: "#404144"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9996 22.824C23.7222 22.824 25.9292 20.617 25.9292 17.8944C25.9292 15.1719 23.7222 12.9648 20.9996 12.9648C18.2771 12.9648 16.0701 15.1719 16.0701 17.8944C16.0701 20.617 18.2771 22.824 20.9996 22.824ZM20.9996 22.824C16.6436 22.824 13.1123 25.4725 13.1123 28.7395M20.9996 22.824C25.3557 22.824 28.887 25.4725 28.887 28.7395",
    stroke: "white",
    strokeWidth: 1.1831,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.e8adb04ed69a8a8751130c587aa1b330.svg";
export { ForwardRef as ReactComponent };